import { useEffect, useState } from "react";
import { jobDataManager } from "../services/jobDataManager";
import type { PushedJob } from "../types/jobs.types";

export const useJobDataManager = () => {
  const [pushedJobs, setPushedJobs] = useState<Map<string, PushedJob>>(() => jobDataManager.getPushedJobs());
  const [lastPushedJob, setLastPushedJob] = useState<PushedJob | null>(() => jobDataManager.getLastPushedJob());

  useEffect(() => {
    const unsubscribe = jobDataManager.subscribe((newPushedJobs, newLastPushedJob) => {
      setPushedJobs(newPushedJobs);
      setLastPushedJob(newLastPushedJob);
    });

    return unsubscribe;
  }, []);

  return { pushedJobs, lastPushedJob };
};
